var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 23,
    height: 23,
    rx: 5.5,
    stroke: "#2F2F37"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.767 15.57H11.055V11.93H8.767V10.5H12.745V15.57H15.15V17H8.767V15.57ZM10.743 8.732C10.743 8.46333 10.8427 8.23367 11.042 8.043C11.2413 7.85233 11.5187 7.757 11.874 7.757C12.238 7.757 12.5283 7.85233 12.745 8.043C12.9617 8.23367 13.07 8.46333 13.07 8.732C13.07 9.00933 12.9617 9.239 12.745 9.421C12.5283 9.59433 12.238 9.681 11.874 9.681C11.5187 9.681 11.2413 9.59433 11.042 9.421C10.8427 9.239 10.743 9.00933 10.743 8.732Z",
    fill: "#2F2F37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestion);
export default __webpack_public_path__ + "static/media/icon-question.0b933d9612c8a7018e54b59c618b7ac8.svg";
export { ForwardRef as ReactComponent };